import { DEFAULT_CULTURE } from '@app/utils/regional'

import { useAppSelector } from '../useAppSelector'

export const useUserCulture = () =>
  useAppSelector((state) => state.user.currentUser.culture || DEFAULT_CULTURE)
